"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _CurrencyFormat = _interopRequireDefault(require("../CurrencyFormat/CurrencyFormat"));
var _excluded = ["price", "isHotelOnly"];
var HotelMenuPrice = function HotelMenuPrice(_ref) {
  var price = _ref.price,
    isHotelOnly = _ref.isHotelOnly,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var _useCurrency = (0, _localization.useCurrency)(),
    code = _useCurrency.code;
  return /*#__PURE__*/_react["default"].createElement(StyledContainer, props, price ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], {
    prefix: t('hotel.menuPrice.valuePrice'),
    value: price,
    currencyCode: code
  }), !isHotelOnly && /*#__PURE__*/_react["default"].createElement("span", null, t('hotel.menuPrice.withFlight'))) : /*#__PURE__*/_react["default"].createElement("span", null, isHotelOnly ? t('hotel.menuPrice.hotelOnly') : t('hotel.menuPrice.tour')));
};
HotelMenuPrice.defaultProps = {
  price: null
};
HotelMenuPrice.propTypes = {
  price: _propTypes["default"].number
};
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelMenuPrice__StyledContainer",
  componentId: "sc-yosrf4-0"
})(["display:flex;align-items:flex-end;gap:5px;color:var(--black);font-size:18px;font-style:normal;font-weight:500;line-height:22px;"]);
var _default = exports["default"] = HotelMenuPrice;